import { createContext, useContext } from 'react'

export type TimeGranularity = 60 | 30 | 15 | 5 | 2 | 1 // timeline partition line in minutes

export type GanttContextType = {
  zoom: number
  setZoom: (zoom: number) => void
  defaultZoom?: number
}

export const GanttContext = createContext<GanttContextType>(null as never)

export const useGanttContext = () => {
  const context = useContext(GanttContext)

  if (context === undefined) {
    throw new Error(
      'useGanttContext must be used within a GanttContext.Provider',
    )
  }

  return context
}